import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Metamodel } from 'app/model/base/model';
import { TarCompressionReadSettings } from 'app/model/pipeline/copysource/compression-read-settings/tar-compression-read-settings';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';
import { CompressionReadSettingsAdapter, compressionReadSettingsAdapts } from './compression-read-settings.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TarCompressionReadSettings),
    asynchronous: true,
    adapts: {
        ...compressionReadSettingsAdapts,
        preserveCompressionFileNameAsFolder: '*'
    }
})
export class TarCompressionReadSettingsAdapter extends CompressionReadSettingsAdapter<
    TarCompressionReadSettings,
    Model.CompressionReadSettings
> {
    protected override async _toResource(model: TarCompressionReadSettings): Promise<Model.CompressionReadSettings> {
        const result: Model.CompressionReadSettings =
            CompressionReadSettingsAdapter.getCommonCompressionReadSettingsProperties(
                Metamodel.modelFor(TarCompressionReadSettings).name
            );
        result.preserveCompressionFileNameAsFolder = ValueAdapter.toResource(
            model,
            TarCompressionReadSettings.PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER
        );
        return result;
    }

    protected override async _toModel(
        resource: Model.CompressionReadSettings,
        formatReadSettings: FormatReadSettings
    ): Promise<TarCompressionReadSettings> {
        const result = CompressionReadSettingsAdapter.createCompressionReadSettingsWithCommonProperties(
            TarCompressionReadSettings.MODEL,
            formatReadSettings
        ) as TarCompressionReadSettings;
        ValueAdapter.toModel(
            result,
            TarCompressionReadSettings.PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER,
            resource.preserveCompressionFileNameAsFolder
        );
        return result;
    }
}
